import React from 'react';
import _ from 'lodash';

import Confirmation from '../../modals/common/Confirmation';

import Style from '../../../styles/componentStyle/worker/safetyDocItemErrorDialog.scss';

/**
 * 安全書類項目確認のダイアログ
 */
const ConfirmationSafetyDocItemDialog = ({
  rootClassName,
  visible,
  errorPropertyList,
  onConfirm,
  onCancel,
}) => {
  return (
    <Confirmation
      rootClassName={`${Style.safetyDocItemErrorDialog} ${rootClassName}`}
      visible={visible}
      title={'未入力項目についての注意'}
      message={
        <SafetyDocItemErrorMessage errorPropertyList={errorPropertyList} />
      }
      confirmButtonText={'このまま登録'}
      onConfirm={onConfirm}
      cancelButtonText={'戻る'}
      onCancel={onCancel}
      tabFocus
    />
  );
};

/**
 * 安全書類項目確認のダイアログメッセージ
 * @props {array} errorPropertyList: エラーになっているプロパティのリスト
 * */
const SafetyDocItemErrorMessage = ({ errorPropertyList }) => {
  // 画面表示
  return (
    <div>
      <p className='description'>
        労務安全書類に出力される項目が未入力です。このまま登録してもよろしいですか？
      </p>
      <p className='description'>
        修正する場合は「戻る」を押し、「安全書類項目」を入力してください。あとから修正することもできます。
      </p>
      <div className='detail'>
        <p className='detail__label'>
          未入力項目は{errorPropertyList.length}件です。
        </p>
        <ul className='detail__item'>
          {_.map(errorPropertyList, (item, index) => {
            return (
              <li className='detail__value' key={index}>
                {item}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default ConfirmationSafetyDocItemDialog;



// WEBPACK FOOTER //
// ./src/components/worker/dialog/ConfirmationSafetyDocItemDialog.js